import { get } from '@/services/API';

export default {
  getLatestAnnouncement: () => get('/api/announcement/latest-announcement'),
};
